import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
} from '@mui/material'
import React from 'react'

interface SaveConstraintsDialogProps {
  saveTemplateModal: boolean
  setSaveTemplateModal: (open: boolean) => void
  constraintsTemplateName: string | null | undefined
  setConstraintsTemplateName: (name: string | null) => void
  handleConstraintTemplateSave: () => void
}

export const SaveConstraintsDialog: React.FC<SaveConstraintsDialogProps> = ({
  saveTemplateModal,
  setSaveTemplateModal,
  constraintsTemplateName,
  setConstraintsTemplateName,
  handleConstraintTemplateSave,
}) => {
  return (
    <Dialog
      open={saveTemplateModal}
      onClose={() => setSaveTemplateModal(false)}
      fullWidth
      maxWidth='xs'
    >
      <DialogTitle>Save Constraint Template</DialogTitle>
      <Divider />
      <DialogContent>
        <TextField
          label='Constraint Template Name'
          variant='standard'
          fullWidth
          value={constraintsTemplateName}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setConstraintsTemplateName(e.target.value)
          }
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button
          variant='contained'
          disabled={
            !constraintsTemplateName || constraintsTemplateName.trim() === ''
          }
          size='small'
          onClick={handleConstraintTemplateSave}
        >
          Save
        </Button>
        <Button
          variant='outlined'
          onClick={() => setSaveTemplateModal(false)}
          size='small'
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  )
}
